import { createReducer, on } from '@ngrx/store';
import { OrderCodeResponse } from './order-code.model';
import { clearOrderCode, loadOrderCode, loadOrderCodeFailure, loadOrderCodeSuccess } from './order-code.actions';

export interface OrderCodeState {
  response: OrderCodeResponse | null;
  // It is any because the error can be of any type, such as string or object
  error: any | null;
  isLoading: boolean;
}

export const initialState: OrderCodeState = {
  response: null,
  error: null,
  isLoading: false,
};

export const orderCodeReducer = createReducer(
  initialState,
  on(loadOrderCode, (state) => ({
    ...state,
    isLoading: true,
    response: null as OrderCodeResponse, // Explicitly setting response to null
    error: null as any, // Explicitly setting error to null
  })),
  on(loadOrderCodeSuccess, (state, { response }) => ({
    ...state,
    isLoading: false,
    response,
    error: null as any, // Explicitly setting error to null
  })),
  on(loadOrderCodeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error,
  })),
  on(clearOrderCode, (state) => ({
    ...state,
    response: null as OrderCodeResponse, // Explicitly setting response to null
    error: null as any, // Explicitly setting error to null
    isLoading: false,
  })),
);
